import _uniqBy from 'lodash/uniqBy';

export default function uniqueMembers(state, mappedMembers, shouldCombine) {
	return shouldCombine ? _uniqBy([...state, ...mappedMembers], 'uuid') : mappedMembers;
}
